// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__BVFr1","info":"Footer_info__FFsLx","desc":"Footer_desc__td5EX","wrapper":"Footer_wrapper__uXSMe"};